class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverCloseTimer = null;
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.onSummaryClickBound = this.onSummaryClick.bind(this);
    this.onHeaderMenuMouseEnterBound = this.onHeaderMenuMouseEnter.bind(this);
    this.onHeaderMenuMouseLeaveBound = this.onHeaderMenuMouseLeave.bind(this);
  }

  closeSiblingMenus() {
    const nav = this.closest('.header__inline-menu');
    if (!nav) return;
    nav.querySelectorAll('header-menu').forEach((menu) => {
      if (menu === this) return;
      const details = menu.mainDetailsToggle;
      if (details && details.hasAttribute('open')) menu.close();
    });
  }

  connectedCallback() {
    this.summary.addEventListener('click', this.onSummaryClickBound, true);
    this.addEventListener('mouseenter', this.onHeaderMenuMouseEnterBound);
    this.addEventListener('mouseleave', this.onHeaderMenuMouseLeaveBound);
  }

  disconnectedCallback() {
    this.clearHoverCloseTimer();
    this.summary.removeEventListener('click', this.onSummaryClickBound, true);
    this.removeEventListener('mouseenter', this.onHeaderMenuMouseEnterBound);
    this.removeEventListener('mouseleave', this.onHeaderMenuMouseLeaveBound);
  }

  isDesktopHoverMenu() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  isMegaMenu() {
    return this.mainDetailsToggle.classList.contains('mega-menu');
  }

  onSummaryClick(e) {
    if (!this.isDesktopHoverMenu()) return;
    if (!this.summary.contains(e.target)) return;
    if (this.isMegaMenu()) return;
    if (e.pointerType === 'mouse' || e.pointerType === 'pen') {
      e.preventDefault();
    }
  }

  onHeaderMenuMouseEnter() {
    if (!this.isDesktopHoverMenu()) return;
    this.clearHoverCloseTimer();
    this.closeSiblingMenus();
    if (this.mainDetailsToggle.hasAttribute('open')) return;
    this.mainDetailsToggle.setAttribute('open', '');
    if (this.summary) this.summary.setAttribute('aria-expanded', 'true');
  }

  onHeaderMenuMouseLeave() {
    this.clearHoverCloseTimer();
    if (!this.isDesktopHoverMenu()) {
      this.close();
      return;
    }
    this.hoverCloseTimer = setTimeout(() => {
      this.close();
      this.hoverCloseTimer = null;
    }, 120);
  }

  clearHoverCloseTimer() {
    if (this.hoverCloseTimer) {
      clearTimeout(this.hoverCloseTimer);
      this.hoverCloseTimer = null;
    }
  }

  close() {
    this.clearHoverCloseTimer();
    super.close();
  }

  onToggle() {
    if (this.mainDetailsToggle.open) this.closeSiblingMenus();
    super.onToggle();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
